import {
  getJDShelfState,//上下架状态
  getJDGoodsGift,//查询赠品信息
  getJDQueryFreight,//运费查询
  getJDSalesCheck,//商品可售验证
  getJDGoodsStock,///查库存，根据SKU和地址
  getJDAreaLimit,// 查询当前sku购买是否有区域限制
  getShopSkuPriceMap,//价格批量查询
  getJDPromiseCalendar,//获取京东预约配送日历
} from '@/api/mall/mallJD'
import { placeGoodsOrder } from '@/api/mall/mallOrder'
import { getAntIntegralWallet } from '@/api/wallet/integral'
import { session } from '@/utils/session'
import { $numAdd, $numSub, $numMulti, $numDiv, } from '@/utils/common'

const state = {
  selectedAddress: {},//已选的地址
  sgOrderGoodsList: [],// 已选订单
  sgOrderGoodsCount: 0,//商品总件数
  sgOrderTotalPrice: 0,//商品总价格
  sgOrderTotalDeductionPrice: 0,//金币可抵扣金额
  sgOrderTotalDeductionCoin: 0,//金币可抵扣金币数量
  
  notGoodsList: [],
  
  sgOrderIsAreaRestrictMap: {},//是否有区域限制--map
  sgOrderCartPriceMap: {},// shopId_sku: 价格--集合
  sgOrderUpDownStatusMap: {},//上下架状态--map
  sgOrderSkusStockMap: {},//库存--map
  sgOrderSalesCheckMap: {},//是否可售校验--map
  sgOrderFreight: 0,//当前订单运费
  calendarListResult: null,//配送日历-中小件货日历
  laCalendarListResult: null,//配送日历-大件货日历
  skuClassifyResult: null,//配送日历-大小件货分类
  
  shopGoodsList: [],//提交订单时的商品数据
  
  Pcoin: {},//缓存 金币 信息
  antWallet: {},//用户金币钱包
  isDeduct: false,//是否使用金币抵扣
}

const mutations = {

}

const actions = {
  initArea: ({state, commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      state.selectedAddress = data
      resolve()
    })
  },
  initGoodsData: ({state, commit, dispatch}, list) => {
    console.log('list', list)
    state.notGoodsList = []
    let province = state.selectedAddress.provinceAreaJdId
    let city = state.selectedAddress.cityAreaJdId
    let county = state.selectedAddress.countyAreaJdId
    let town = state.selectedAddress.townAreaJdId || 0;
    let area = `${province}_${city}_${county}`;
    if(town){area += ('_'+town);}
    
    let areaLimitReq = {skuIds: ''} //区域限制
    let priceReq = {list: []} // 价格
    let shelfStateReq = {sku: ''} // 上下架状态
    let goodsStockReq = {skuNums: [], area} // 库存
    let freightReq = {sku: [], province, city, county, town, paymentType: 4} // 运费
    let calendarReq = {sku: [],province, city, county, town, paymentType: 4} // 预约配送日历
    let salesChecReq = {skuIds: '', queryExts: 'noReasonToReturn,thwa,isSelf,isJDLogistics,taxInfo'} // 是否可售校验
    list.map(item=>{
      item.shopItems.map(item2=>{
        areaLimitReq.skuIds += item2.productCode+',' //区域限制
        priceReq.list.push({shopId: item.shopId, jdSku: item2.productCode,fetchIntegralDeductAmount: true})//价格
        shelfStateReq.sku += item2.productCode+',' //上下架状态
        goodsStockReq.skuNums.push({skuId: item2.productCode, num: item2.productCount}) //库存
        calendarReq.sku.push({skuId: item2.productCode, num: item2.productCount}) //预约配送日历
        salesChecReq.skuIds += item2.productCode+',' //是否可售校验
        freightReq.sku.push({skuId: item2.productCode, num: item2.productCount}) //运费
      })
    })
    let count = 0, price = 0, orderShopGoodsList = [], deductionPrice=0;
    let inviteBuyData = session('inviteBuyData') ? session('inviteBuyData') : {};
    dispatch('getShopSkuPriceMap', priceReq).then(
      dispatch('listJDShelfState', shelfStateReq).then(
        dispatch('listJDGoodsStock', goodsStockReq).then(
          dispatch('listJDSalesCheck', salesChecReq).then(
            dispatch('getJDQueryFreight', freightReq).then(()=>{
              let sgOrderGoodsList = list.map(item=>{
                let shopGoodsNumberCount = 0, orderShopGoodsListItem = {};
                orderShopGoodsListItem.shopId = item.shopId
                orderShopGoodsListItem.memberPriceUsed = false
                orderShopGoodsListItem.goodsList = []
                let shopItems = item.shopItems.map(item2=>{
                  //-------------------------------------//
                  let orderGoodsListItem = {
                    count: item2.productCount,
                    goodsId: item2.goodsId,
                    goodsType: item2.goodsType,
                    productCode: item2.productCode,
                    productId: item2.productId,
                  }
                  if(inviteBuyData[item.shopId+'_'+item2.goodsId]){//是否有邀请用户id
                    orderGoodsListItem.inviteUserId = inviteBuyData[item.shopId+'_'+item2.goodsId]
                  }
                  orderShopGoodsListItem.goodsList.push(orderGoodsListItem)
                  //-------------------------------------//
                  shopGoodsNumberCount += item2.productCount
                  item2.mapPrice = state.sgOrderCartPriceMap[item.shopId+'_'+item2.productCode]//价格信息
                  item2.mapUpDownStatus = state.sgOrderUpDownStatusMap[item2.productCode]//是否上下架
                  item2.mapSkusStock = state.sgOrderSkusStockMap[item2.productCode]//库存
                  item2.mapSalesCheck = state.sgOrderSalesCheckMap[item2.productCode]//可售校验
                  count += (item2.productCount)//统计商品件数
                  price += (item2.productCount * item2.mapPrice.sellPrice)//统计商品总价
                  deductionPrice += (item2.productCount * (item2.mapPrice.integralDeductCashAmount||0)) //金币可抵扣金额
                  //判断是否为无货商品
                  if(item2.mapSkusStock.stockStateId===34 || item2.mapSkusStock.stockStateId===36 || item2.mapSalesCheck.saleState!==1){//33 有货现货-下单立即发货；34 无货；39 有货在途-正在内部配货，预计2~6天到达本仓库；40 有货可配货-下单后从有货仓库配货；36 预订；
                    state.notGoodsList.push(item2)
                  }
                  
                  return item2
                })
                item.shopGoodsNumberCount = shopGoodsNumberCount
                item.shopItems = shopItems
                orderShopGoodsList.push(orderShopGoodsListItem)
                return item
              })
              state.shopGoodsList = orderShopGoodsList
              state.sgOrderGoodsList = sgOrderGoodsList
              state.sgOrderGoodsCount = count
              state.sgOrderTotalPrice = price
              state.sgOrderTotalDeductionPrice = deductionPrice
              }
            ).then(()=>{
              state.sgOrderTotalDeductionCoin = parseInt( $numDiv( state.sgOrderTotalDeductionPrice, state.Pcoin.buyPrice ) )
              // state.sgOrderTotalDeductionCoin = $numDiv( state.sgOrderTotalDeductionPrice, state.Pcoin.buyPrice )
            })
          )
        )
      )
    )
    dispatch('getJDPromiseCalendar', calendarReq)
  },
  
  //批量查询商品价格信息
  getShopSkuPriceMap: ({state, commit, dispatch}, req) => {
    let sgOrderCartPriceMap = Object.assign({}, state.sgOrderCartPriceMap)
    return new Promise((resolve, reject) => {
      getShopSkuPriceMap(req).then(res=>{
        if(res.code===200){
          let data = res.data
          Object.keys(data).forEach(key=>{
            sgOrderCartPriceMap[key] = data[key] || {sellPrice: 0,displayOriginalPrice: 0}
          })
          state.sgOrderCartPriceMap = sgOrderCartPriceMap
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //批量查询是否是否有区域限制(依赖地址)
  listJDAreaLimit: ({ state, commit, dispatch }, data) => {
    let req = Object.assign({}, data)
    req.province = state.selectedAddress.provinceAreaJdId
    req.city = state.selectedAddress.cityAreaJdId
    req.county = state.selectedAddress.countyAreaJdId
    req.town = state.selectedAddress.townAreaJdId || 0
    if(!req.county){
      console.error('county, 无位置数据', req.county)
      return false
    }
    let sgOrderIsAreaRestrictMap = Object.assign({}, state.sgOrderIsAreaRestrictMap)
    return new Promise((resolve, reject) => {
      getJDAreaLimit(req).then(res=>{
        if(res.code===200){
          let data = res.data
          data.forEach(item=>{
            sgOrderIsAreaRestrictMap[item.skuId] = item.isAreaRestrict
          })
          state.sgOrderIsAreaRestrictMap = sgOrderIsAreaRestrictMap
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //批量查询是否上下架
  listJDShelfState: ({ state, commit, dispatch }, req) => {
    let sgOrderUpDownStatusMap = Object.assign({}, state.sgOrderUpDownStatusMap)
    return new Promise((resolve, reject) => {
      getJDShelfState(req).then(res=>{
        if(res.code===200){
          let data = res.data
          data.forEach(item=>{
            sgOrderUpDownStatusMap[item.sku] = item
          })
          state.sgOrderUpDownStatusMap = sgOrderUpDownStatusMap
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //批量查sku库存(依赖地址)
  listJDGoodsStock:({ state, commit, dispatch }, data) => {
    let req = Object.assign({}, data)
    if(!state.selectedAddress.countyAreaJdId){
      console.error('req.area, 无位置数据', req.area)
      return false
    }
    let sgOrderSkusStockMap = Object.assign({}, state.sgOrderSkusStockMap)
    return new Promise((resolve, reject) => {
      getJDGoodsStock(req).then(res=>{
        if(res.code===200){
          let data = res.data
          data.forEach(item=>{
            sgOrderSkusStockMap[item.skuId] = item
          })
          state.sgOrderSkusStockMap = sgOrderSkusStockMap
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //校验商品是否可售
  listJDSalesCheck: ({ state, commit, dispatch }, data) => {
    let req = Object.assign({}, data)
    let sgOrderSalesCheckMap = Object.assign({}, state.sgOrderSalesCheckMap)
    return new Promise((resolve, reject) => {
      getJDSalesCheck(req).then(res=>{
        if(res.code===200){
          let data = res.data
          data.forEach(item=>{
            sgOrderSalesCheckMap[item.skuId] = item
          })
          state.sgOrderSalesCheckMap = sgOrderSalesCheckMap
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //获取预约配送日历
  getJDPromiseCalendar: ({state, commit, dispatch}, req) => {
    console.log(req)
    return new Promise((resolve, reject) => {
      getJDPromiseCalendar(req).then(res=>{
        if(res.code===200){
          state.calendarListResult = res.data.calendarListResult===null ? null : Object.assign({}, res.data.calendarListResult)
          state.laCalendarListResult = res.data.laCalendarListResult===null ? null : Object.assign({}, res.data.laCalendarListResult)
          state.skuClassifyResult = Object.assign({}, res.data.skuClassifyResult)
          console.log(state.calendarListResult,  state.laCalendarListResult, state.skuClassifyResult)
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  //查询运费
  getJDQueryFreight: ({state, commit, dispatch}, req)=>{
    return new Promise((resolve, reject) => {
      getJDQueryFreight(req).then(res=>{
        if(res.code===200){
          state.sgOrderFreight = res.data.freight || 0;
        }
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 提交订单
  placeGoodsOrder: ({state, commit, dispatch}, reqData) => {
    let req = Object.assign({}, reqData)
    req.shopGoodsList = state.shopGoodsList
    console.log(req)
    return new Promise((resolve, reject) => {
      placeGoodsOrder(req).then(res=>{
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // 设置金币信息
  setPlatformCoin: ({state, commit, dispatch}, data) => {
    return new Promise((resolve, reject) => {
      state.Pcoin = data
      console.log('state.Pcoin', state.Pcoin )
      resolve()
    })
  },
  
  // 获取个人金币钱包余额
  getAntIntegralWallet: ({state, commit, dispatch}, reqData) => {
    let req = Object.assign({}, reqData)
    req.shopGoodsList = state.shopGoodsList
    console.log(req)
    return new Promise((resolve, reject) => {
      getAntIntegralWallet(req).then(res=>{
        state.antWallet = res.data
        resolve(res.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  changeIsDeduct: ({state, commit, dispatch}, flag) => {
    return new Promise((resolve, reject) => {
      state.isDeduct = flag
      resolve()
    })
  },
  
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}